var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:{ 'can-overflow': _vm.overflow },style:({ 'background-image': `url(${_vm.image})` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }